import { CommonService } from 'wire-frame';
import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { ToasterService } from './service/common/toaster.service';

export const authGuard: CanActivateChildFn = (childRoute, state) => {
  const common = inject(CommonService);
  const toast = inject(ToasterService);
  const storageUserKey = 'loggedInUser_persist';
  const token = localStorage.getItem('jwtToken');
  let sessionUserRaw = sessionStorage.getItem('loggedInUser');

  // Restore user context for fresh/background tabs where sessionStorage is empty.
  if (!sessionUserRaw && token) {
    const persistedUserRaw = localStorage.getItem(storageUserKey);
    if (persistedUserRaw) {
      sessionStorage.setItem('loggedInUser', persistedUserRaw);
      sessionUserRaw = persistedUserRaw;
    }
  }

  const loggedInUser = JSON.parse(sessionUserRaw || '{}');

  // Keep a stable copy in localStorage for cross-tab restore.
  if (loggedInUser && Object.keys(loggedInUser).length) {
    localStorage.setItem(storageUserKey, JSON.stringify(loggedInUser));
  }

  const allowedPaths: { [key: string]: string[] } = {
    reception: [
      '/admin/dashboard',
      '/admin/appointment',
      '/admin/appointment-list',
      '/admin/appointment-kanban',
      '/admin/patient-registration',
      '/admin/pharmacy',
      '/admin/certificates',
      '/admin/bills',
      '/admin/reception-dues',
    ],
    assistant_doctor: [
      '/admin/dashboard',
      '/admin/pre-consultation',
      '/admin/patient-registration',
      '/admin/pharmacy',
      '/admin/certificates',
      '/admin/bills',
      '/admin/medicine-finder',
      '/admin/repertory',
    ],
    doctor: [
      '/admin/dashboard',
      '/admin/appointment',
      '/admin/appointment-list',
      '/admin/appointment-kanban',
      '/admin/prescriptions',
      '/admin/patient-registration',
      '/admin/pharmacy',
      '/admin/medicine',
      '/admin/certificates',
      '/admin/bills',
      '/admin/medicine-finder',
      '/admin/repertory',
      '/admin/analytics-collections',
      '/admin/reception-dues',
    ],
    pharmacy: [
      '/admin/dashboard',
      '/admin/pharmacy',
      '/admin/medicine',
    ],
  };

  const loggedInUserType = loggedInUser.type;
  const baseUrl = state.url.split('?')[0];
  // if (allowedPaths.hasOwnProperty(loggedInUserType) && allowedPaths[loggedInUserType].includes(state.url)) {

  if (
    allowedPaths.hasOwnProperty(loggedInUserType) &&
    allowedPaths[loggedInUserType].includes(baseUrl)
  ) {
    const menus: any[] = [];
    if (loggedInUser.type === 'reception') {
      menus.push(
        {
          title: 'Dashboard',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>`,
          isActive: true,
          path: '/admin/reception-dues',
        },
        {
          title: 'Appointments',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Appointment Calendar',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`,
              path: '/admin/appointment',
            },
            {
              title: 'Appointment List',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>`,
              path: '/admin/appointment-list',
            },
            {
              title: 'Appointment Kanban',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="5" height="18" rx="1"/><rect x="10" y="3" width="5" height="13" rx="1"/><rect x="17" y="3" width="5" height="16" rx="1"/></svg>`,
              path: '/admin/appointment-kanban',
            },
          ],
        },
        {
          title: 'Patients',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Patient Registration',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>`,
              path: '/admin/patient-registration',
            }
          ],
        },
        {
          title: 'Pharmacy',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"/><path d="m8.5 8.5 7 7"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Dispense Medicine',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 2 4 4"/><path d="m17 7 3-3"/><path d="M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5"/><path d="m9 11 4 4"/><path d="m5 19-3 3"/><path d="m14 4 6 6"/></svg>`,
              path: '/admin/pharmacy',
            }
          ],
        },
        {
          title: 'Certificates & Bills',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Certificates',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>`,
              path: '/admin/certificates',
            },
            {
              title: 'Bills',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>`,
              path: '/admin/bills',
            },
          ],
        },
      );
    } else if (loggedInUser.type === 'assistant_doctor') {
      menus.push(
        {
          title: 'Patients',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Pre Consultation',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>`,
              path: '/admin/pre-consultation',
            },
            {
              title: 'Patient Registration',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>`,
              path: '/admin/patient-registration',
            },
          ],
        },
        {
          title: 'Pharmacy',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"/><path d="m8.5 8.5 7 7"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Dispense Medicine',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 2 4 4"/><path d="m17 7 3-3"/><path d="M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5"/><path d="m9 11 4 4"/><path d="m5 19-3 3"/><path d="m14 4 6 6"/></svg>`,
              path: '/admin/pharmacy',
            }
          ],
        },
        {
          title: 'Certificates & Bills',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Certificates',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>`,
              path: '/admin/certificates',
            },
            {
              title: 'Bills',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>`,
              path: '/admin/bills',
            },
          ],
        },
        // {
        //   title: 'Medicine Finder',
        //   icon1: 'home',
        //   isActive: true,
        //   items: [
        //     {
        //       title: 'Medicine Finder',
        //       icon1: 'home',
        //       path: '/admin/medicine-finder',
        //     },
        //   ],
        // },
        // {
        //   title: 'Repertory',
        //   icon1: 'home',
        //   icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/><line x1="8" y1="7" x2="16" y2="7"/><line x1="8" y1="11" x2="13" y2="11"/></svg>`,
        //   isActive: true,
        //   path: '/admin/repertory',
        // },
      );
    } else if (loggedInUser.type === 'doctor') {
      menus.push(
        // {
        //   "title": "Employee Master",
        //   "icon": "user",
        //   "path": "/admin/employee",
        //   "hideFor": "isInvestigator"
        // },
        {
          title: 'Appointments',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Appointment Calendar',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>`,
              path: '/admin/appointment',
            },
            {
              title: 'Appointment List',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>`,
              path: '/admin/appointment-list',
            },
            {
              title: 'Appointment Kanban',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="5" height="18" rx="1"/><rect x="10" y="3" width="5" height="13" rx="1"/><rect x="17" y="3" width="5" height="16" rx="1"/></svg>`,
              path: '/admin/appointment-kanban',
            },
          ],
        },
        {
          title: 'Patients',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Prescriptions',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>`,
              path: '/admin/prescriptions',
            },
            {
              title: 'Patient Registration',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>`,
              path: '/admin/patient-registration',
            },
            {
              title: 'Dues Notifications',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>`,
              path: '/admin/reception-dues',
            }
          ],
        },
        {
          title: 'Pharmacy',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"/><path d="m8.5 8.5 7 7"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Dispense Medicine',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 2 4 4"/><path d="m17 7 3-3"/><path d="M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5"/><path d="m9 11 4 4"/><path d="m5 19-3 3"/><path d="m14 4 6 6"/></svg>`,
              path: '/admin/pharmacy',
            },
            {
              title: 'Manage Medicine',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>`,
              path: '/admin/medicine',
            },
          ],
        },
        {
          title: 'Certificates & Bills',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Certificates',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>`,
              path: '/admin/certificates',
            },
            {
              title: 'Bills',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>`,
              path: '/admin/bills',
            },
          ],
        },
        // {
        //   title: 'Medicine Finder',
        //   icon1: 'home',
        //   isActive: true,
        //   path: '/admin/medicine-finder',
        // },
        {
          title: 'Reports',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>`,
          isActive: true,
          path: '/admin/analytics-collections',
        },
        // {
        //   title: 'Repertory',
        //   icon1: 'home',
        //   icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/><line x1="8" y1="7" x2="16" y2="7"/><line x1="8" y1="11" x2="13" y2="11"/></svg>`,
        //   isActive: true,
        //   path: '/admin/repertory',
        // }
      );
    } else if (loggedInUser.type === 'pharmacy') {
      menus.push(
        {
          title: 'Pharmacy',
          icon1: 'home',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"/><path d="m8.5 8.5 7 7"/></svg>`,
          isActive: true,
          items: [
            {
              title: 'Dispense Medicine',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 2 4 4"/><path d="m17 7 3-3"/><path d="M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5"/><path d="m9 11 4 4"/><path d="m5 19-3 3"/><path d="m14 4 6 6"/></svg>`,
              path: '/admin/pharmacy',
            },
            {
              title: 'Manage Medicine',
              icon1: 'home',
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>`,
              path: '/admin/medicine',
            },
          ],
        }
      );
    }
    common.setMenu([]);
    common.setMenu(menus);
    return true;
  } else {
    common.setMenu([]);
    toast.warn('Warning', 'You are not permitted to access this page');
    common.redirect('/admin/dashboard');
    return false; // Prevent navigation for unknown user types
  }

};
